/**
 * Page manager sections visibility types
 * @module services/pm-section/visibility-types
 */

export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_LOGGED_IN = 'logged-in'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_TENURE = 'tenure-rules'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_FMTV_ONLY = 'fmtv-only'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_VTS = 'vts-rules'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_MY_SERIES_MIN_ITEMS = 'my-series-min-items'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_FOLLOWED_SERIES_MIN_ITEMS =
  'followed-series-min-items'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_ONBOARD_TERMS = 'user-onboard-terms'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_RC_TERMS = 'user-rc-terms'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_TEST_GROUP = 'user-test-group'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_HAS_WATCHED = 'user-has-watched'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_FOLLOWING = 'user-following'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_ENTITLEMENT = 'user-entitlement'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_UBS = 'ubs-rules'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_CONTENT_IMPRESSION = 'content-impression'
export const PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_VIEW_COUNT = 'user-view-count'
